import { portfolioSelectorService } from "./app/portfolio/portfolioSelector";
import { AuthService } from "./app/common/auth.service";
import * as _ from "lodash";

export default routesConfig;
const topPortfoliosParams =
  "topCombinedHoldings&topCombinedEquityHoldings&topCombinedFixedIncomeHoldings&topLocalHoldings&topLocalEquityHoldings&topLocalFixedIncomeHoldings&topInternationalHoldings&topInternationalEquityHoldings&topInternationalFixedIncomeHoldings";
const benchmarkParams =
  "combinedBenchmark&localBenchmark&internationalBenchmark&combinedBenchmarkPrimary&localBenchmarkPrimary&internationalBenchmarkPrimary&combinedBenchmarkSecondary&localBenchmarkSecondary&internationalBenchmarkSecondary";
/** @ngInject */
function routesConfig(
  $stateProvider: any /*angular.ui.IStateProvider*/,
  $urlRouterProvider: angular.ui.IUrlRouterProvider,
  $locationProvider: angular.ILocationProvider
) {
  $locationProvider.html5Mode(true).hashPrefix("!");

  $urlRouterProvider.otherwise("/");

  $stateProvider
    .state("root", {
      url: "/",
      component: "app",
      abstract: true,
    })
    .state("login", {
      url: "/login",
      component: "login",
    })
    .state("clientonboarding", {
      url: "/clientonboarding",
      component: "clientonboarding",
    })
    .state("reporting", {
      url: "/reporting",
      component: "reportingMain",
      abstract: true,
    })
    // .state('root.dashboard', {
    //   url: 'dashboard',
    //   component: 'portfolioSummary',
    //   ncyBreadcrumb: {
    //     label: 'Portfolio'
    //   }
    // })

    // Portfolio Manager Dashboard
    .state("root.portfolioManagement", {
      url: "portfolioManagement",
      component: "portfolioManagerSummary",
      ncyBreadcrumb: {
        label: "Portfolio Management",
      },
    })

    // security balances
    .state("root.portfolioManagement.clientBalances", {
      url: "/securities/:securityId/clients/balances",
      views: {
        "@root": {
          component: "clientBalances",
        },
      },
      ncyBreadcrumb: {
        label: "Client Balances",
      },
    })

    // Client Stuff
    .state("root.clients", {
      url: "clients",
      component: "clients",
      ncyBreadcrumb: {
        label: "Clients",
      },
    })

    .state("root.portfolioManagement.clients", {
      url: "/clients",
      views: {
        "@root": {
          component: "clients",
        },
      },
      ncyBreadcrumb: {
        label: "Clients",
      },
    })
    .state("root.portfolioManagement.clients.detail", {
      url: "/:id?tab",
      views: {
        "@root": {
          component: "clientDetails",
        },
      },
      ncyBreadcrumb: {
        label: "Client Details",
      },
    })
    .state("root.portfolioManagement.clients.portfolio", {
      url: "/:clientNumber/portfolioadmin",
      views: {
        "@root": {
          component: "portfolioadmin",
        },
      },
      ncyBreadcrumb: {
        label: "Portfolio Administration",
      },
    })

    // Line-Item Trading/Simulations
    .state("root.portfolioManagement.simulations", {
      url: "/simulations",
      views: {
        "@root": {
          component: "simulations",
        },
      },

      ncyBreadcrumb: {
        label: "Simulations",
      },
    })

    // Portfolio Trading Management
    .state("root.portfolioManagement.trading", {
      url: "/trading",
      views: {
        "@root": {
          component: "trading",
        },
      },

      ncyBreadcrumb: {
        label: "Trading",
      },
    })
    .state("root.portfolioManagement.exchangeRates", {
      url: "/exchangeRates",
      views: {
        "@root": {
          component: "portfolioManagerExchangeRates",
        },
      },

      ncyBreadcrumb: {
        label: "Exchange Rates",
      },
    })

    .state("root.email", {
      url: "emails",
      component: "emails",
      ncyBreadcrumb: {
        label: "Mass Mailing",
      },
    })

    .state("root.email.create", {
      url: "/create",
      views: {
        "@root": {
          component: "createEmail",
        },
      },
      ncyBreadcrumb: {
        label: "Draft",
      },
    })

    // Trading Administration
    .state("root.tradingAdmin", {
      url: "tradingAdministration",
      component: "tradingAdmin",
      ncyBreadcrumb: {
        label: "Trading Administration",
      },
    })

    // fees management
    .state("root.fees", {
      url: "fees",
      component: "fees",
      ncyBreadcrumb: {
        label: "Fee Management",
      },
    })
    .state("root.fees.feeTypes", {
      url: "/feeTypes",
      views: {
        "@root": {
          component: "feeTypeManagement",
        },
      },
      ncyBreadcrumb: {
        label: "Fee Types",
      },
    })
    .state("root.fees.clientFees", {
      url: "/clientFees",
      views: {
        "@root": {
          component: "clientFeeManagement",
        },
      },
      ncyBreadcrumb: {
        label: "Client Fees",
      },
    })
    .state("root.fees.instructions", {
      url: "/instructions",
      views: {
        "@root": {
          component: "instructions",
        },
      },
      ncyBreadcrumb: {
        label: "Instructions",
      },
    })
    .state("root.fees.cashAccounts", {
      url: "/cashaccounts",
      views: {
        "@root": {
          component: "managementFeeCashAccount",
        },
      },
      ncyBreadcrumb: {
        label: "Cash Accounts",
      },
    })
    .state("root.fees.portfolioSummary", {
      url: "/portfolioSummary",
      views: {
        "@root": {
          component: "activityDashboard",
        },
      },
      resolve: {
        mode: () => 'portfolio',
      },
      ncyBreadcrumb: {
        label: "Portfolio Summary",
      },
    })

    // users

    .state("root.users", {
      url: "users",
      component: "userList",
      ncyBreadcrumb: {
        label: "User Management",
      },
    })

    .state("root.users.create", {
      url: "/create",
      views: {
        "@root": {
          component: "addUserDetails",
        },
      },
      params: {
        user: null,
      },
      ncyBreadcrumb: {
        label: "New User",
      },
    })

    .state("root.users.create.clients", {
      url: "/:id/clients",
      views: {
        "@root": {
          component: "assignClients",
        },
      },
      params: {
        user: null,
      },
      ncyBreadcrumb: {
        label: "Assign Clients",
      },
    })

    .state("root.users.details", {
      url: "/:id",
      views: {
        "@root": {
          component: "userInfo",
        },
      },
      ncyBreadcrumb: {
        label: "User Details",
      },
    })

    .state("root.fileproviders", {
      url: "fileproviders",
      component: "fileList",
      ncyBreadcrumb: {
        label: "File Provider Management",
      },
    })

    .state("root.fileproviders.details", {
      url: "/:username",
      views: {
        "@root": {
          component: "fileInfo",
        },
      },
      ncyBreadcrumb: {
        label: "File Provider Details",
      },
    })

    .state("root.fileproviders.create", {
      url: "/create",
      views: {
        "@root": {
          component: "newFile",
        },
      },
      ncyBreadcrumb: {
        label: "New File Provider",
      },
    })

    .state("root.communication", {
      url: "communication",
      component: "commList",
      ncyBreadcrumb: {
        label: "Client Communications",
      },
    })

    .state("root.communication.create", {
      url: "/create",
      views: {
        "@root": {
          component: "newComm",
        },
      },
      ncyBreadcrumb: {
        label: "New Client Communication",
      },
    })

    .state("root.clientapplication", {
      url: "clientapplication",
      component: "clientapplication",
      ncyBreadcrumb: {
        label: "Client Onboarding",
      },
    })
    .state("root.clientmanagement", {
      url: "clientmanagement",
      component: "clientmanagement",
      ncyBreadcrumb: {
        label: "Configuration",
      },
    })
    .state("root.personaldetails", {
      url: "personaldetails",
      component: "registeredClient",
      ncyBreadcrumb: {
        label: "Personal Details",
      },
    })

    // Portfolio Stuff!!!!

    .state("root.portfolio", {
      url: "portfolio",
      views: {
        "portfolioSelector@root": {
          component: "portfolioSelector",
        },
      },
      abstract: true,
      resolve: {
        potentialPortfolios: function (
          portfolioSelectorService: portfolioSelectorService
        ) {
          return portfolioSelectorService.getUserPortfolios();
        },
      },
    })
    .state("root.portfolio.portfolioSummary", {
      url: "/portfolioSummary",
      views: {
        "@root": {
          component: "portfolioSummary",
        },
      },
      ncyBreadcrumb: {
        label: "Portfolio Summary",
      },
    })
    .state("root.portfolio.performance", {
      url: "/performance",
      views: {
        "@root": {
          component: "performance",
        },
      },
      ncyBreadcrumb: {
        label: "Performance",
      },
    })
    .state("root.portfolio.portfolioSummary.mauritius", {
      url: "/mauritius",
      views: {
        "@root": {
          component: "portfolioMauritius",
        },
      },
      ncyBreadcrumb: {
        label: "Mauritius",
      },
    })
    .state("root.portfolio.portfolioSummary.international", {
      url: "/international",
      views: {
        "@root": {
          component: "portfolioInternational",
        },
      },
      ncyBreadcrumb: {
        label: "International",
      },
    })
    .state("root.portfolio.portfolioSummary.geographyAndSector", {
      url: "/geographyandsector",
      views: {
        "@root": {
          component: "geographyAndSector",
        },
      },
      ncyBreadcrumb: {
        label: "Geography and Sector",
      },
    })

    // CModel

    .state("root.cmodel", {
      url: "cmodel",
      component: "cModel",
      ncyBreadcrumb: {
        label: "Confident Model",
      },
    })
    .state("root.cmodel.international", {
      url: "/international",
      views: {
        "@root": {
          component: "cModelInternational",
        },
      },
      ncyBreadcrumb: {
        label: "International",
      },
    })
    .state("root.cmodel.mauritius", {
      url: "/mauritius",
      views: {
        "@root": {
          component: "cModelMauritius",
        },
      },
      ncyBreadcrumb: {
        label: "Mauritius",
      },
    })
    .state("root.cmodel.securitymanagement", {
      url: "/securitymanagement",
      views: {
        "@root": {
          component: "cModelSecurityManagement",
        },
      },
      ncyBreadcrumb: {
        label: "Security Management",
      },
    })
    .state("root.cmodel.reportSummary", {
      url: "/reportSummary",
      views: {
        "@root": {
          component: "reportSummary",
        },
      },
      ncyBreadcrumb: {
        label: "Report Summary",
      },
    })

    .state("root.contactus", {
      url: "contactus",
      component: "contactus",
      ncyBreadcrumb: {
        label: "Contact Us",
      },
    })
    .state("root.transactions", {
      url: "transactions",
      component: "transactions",
      ncyBreadcrumb: {
        label: "Transactions",
      },
    })

    // Reports - admin report pages
    .state("root.reports", {
      url: "reports",
      component: "reports",
      ncyBreadcrumb: {
        label: "Reports",
      },
    })

    // Reporting - puppeteer generated pages for reports
    .state("reporting.portfolio", {
      url: `/portfolio?portfolioIds&currency&reportFolder&clientNumber&userId&fromDate&toDate&displayLocalPerformance&displayInternationalPerformance&displayMonthlyPerformance&displayLineItems&isReconciled&inceptionPerf&trailingTwelveMonthsPerf&currencySplit&displayBenchmarkPerformance&${topPortfoliosParams}&${benchmarkParams}&strategyGoingForward&finYearToDate&lastTransaction&portfolioAttribution`,
      component: "portfolioSummaryReport",
    })

    // Compliance
    .state("root.compliance", {
      url: "compliance",
      component: "compliance",
      ncyBreadcrumb: {
        label: "Compliance",
      },
    });
}



// WEBPACK FOOTER //
// ./src/routes.ts